import React from "react";
import { WhiteContainer } from "../../../../../styles/orderform.tsx";
import { styled } from "styled-components";

const SelectedValueContainer = styled.div`

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;

  .product-name {
    color: var(--Lumme);
    font-weight: 700;
    cursor: pointer;
    border: none;
  }
`;

function ClosedWhiteContainer({ text, value, handleClick, classes }: { text: string, value: string, handleClick?: () => void, classes?: string }) {
  return (
      <WhiteContainer className={classes}>
        <SelectedValueContainer>
          {text} {value && <button type="button" className="product-name" onClick={handleClick}>{value}</button>}
        </SelectedValueContainer>
      </WhiteContainer>
  );
}

export default ClosedWhiteContainer;
